// extracted by mini-css-extract-plugin
export default {"noc-subjects-chart--table":"style_noc-subjects-chart--table__OvI6E"};